export default __webpack_public_path__ + "static/media/pu.18adf558.jpg";